exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image-create .cropper-toolbar{margin-bottom:6px\n}\n.image-create .cropper-toolbar .btn-group{margin-right:4px\n}\n.image-create .cropper-img{display:inline-block;max-width:900px\n}\n.image-create .img-src{display:none\n}\n.image-create .cropped{border:1px solid gray;height:150px;width:200px\n}\n.image-create .hover:hover{color:blue\n}", ""]);

// exports
